<app-base-widget [card]="false" attr.data-cy="seriesNavDisConChart{{portfolioId()}}{{series().masterId}}">
    <app-gcm-chart [noMerge]="true" [chartStyle]="cumulativeChartStyle" [chartOptions]="chartConfig" />
</app-base-widget>